import { render, staticRenderFns } from "./AppNameModal.vue?vue&type=template&id=39eae808&"
import script from "./AppNameModal.vue?vue&type=script&lang=js&"
export * from "./AppNameModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39eae808')) {
      api.createRecord('39eae808', component.options)
    } else {
      api.reload('39eae808', component.options)
    }
    module.hot.accept("./AppNameModal.vue?vue&type=template&id=39eae808&", function () {
      api.rerender('39eae808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/AppNameModal.vue"
export default component.exports